<template>
  <div style="display: flex; flex-direction: row; justify-content: space-between">
    <wrapper-preview-category style="width: 48%">
      <template v-slot:header>Блокировка и печать заявки</template>
      <v-divider class="my-3"/>
      <v-row v-if="!organizationBlocked">
        <v-col class="d-flex justify-start">
          Печать появится после блокировки
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-start">
          <v-btn
            v-if="!organizationBlocked"
            class="blue__v-btn mr-5"
            :loading="loadingFile"
            :disabled="blockBtn"
            @click="getReport"
          >
            Формы для самопроверки
          </v-btn>
        </v-col>
      </v-row>
      <template v-if="organizationBlocked">
        <file-container :cols="9" :currentStage="currentStage" :files-config="filesConfig"/>
        <v-row class="mt-2">
          <v-col class="d-flex justify-start">
            <v-btn
              class="blue__v-btn"
              :loading="loadingFile"
              :disabled="blockBtn"
              @click="getReport"
            >
              Печать
            </v-btn>
          </v-col>
        </v-row>
        <v-divider class="my-3"/>
        <v-row>
          <v-col class=" d-flex justify-start">
            <v-btn
              class="blue__v-btn"
              @click="envelopeConfirm = true"
              :loading="loadingKonvert"
              :disabled="blockBtn"
            >
              {{ organizationSendKonvert ? 'Конверт отправлен' : 'Отправить конверт' }}
            </v-btn>
          </v-col>
        </v-row>
        <v-dialog v-model="envelopeConfirm" width="700">
          <v-card>
            <v-card-title>После отправки конверта разблокировать кабинет будет нельзя.</v-card-title>
            <v-card-actions style="justify-content: space-evenly">
              <v-btn class="blue__v-btn pr-3" @click="blockKonvertOrg">Отправить</v-btn>
              <v-btn class="blue__v-btn pl-3" @click="envelopeConfirm = false">Отменить</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <v-divider class="my-3"/>
      <v-row>
        <v-col class="d-flex justify-start">
          <v-btn
            :class="organizationBlocked ? 'success__v-btn' : 'error__v-btn'"
            @click="blockOrg"
            :loading="loading"
            :disabled="blockBtn"
          >
            {{ organizationBlocked ? 'Разблокировать' : 'Заблокировать' }}
          </v-btn>
        </v-col>
      </v-row>
    </wrapper-preview-category>
    <div
      v-if="getBlockInfoOrganization.konvert && organizationBlocked"
      style="width: 48%" :class="konvertAcceptStatus"
    >
      <div class="application__status">
        <div>{{ konvertAcceptText }}</div>
        <div class="convert_span">Номер: {{ getBlockInfoOrganization.konvertNumber }}</div>
        <div class="convert_span">Дата: {{ receiptDate }}</div>
      </div>
    </div>
    <v-dialog v-model="errors.hasErrors" width="1200">
      <v-card>
        <v-card-title>Конкурсные группы по которым значения выходят за установленные ограничения</v-card-title>
        <v-card-text v-for="item in errors.errorsArray" :key="item.id" style="color: #00599B; font-weight: 500; ">
          {{ item }}
        </v-card-text>
        <v-card-actions style="justify-content: space-evenly">
          <v-btn class="blue__v-btn pl-3" @click="errors.hasErrors = false">Ок</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import {mapGetters} from "vuex";
import UserController from "@/controllers/UserController";
import FileContainer from "@/containers/FileContainer";
import {setFileFunctions} from "@/mixins/fileFucntions";
import moment from 'moment';

moment.locale('ru');

export default {
  name: "BlockPrint",
  components: {FileContainer, WrapperPreviewCategory},
  mixins: [setFileFunctions],
  data() {
    return {
      loading: false,
      loadingKonvert: false,
      loadingFile: false,
      envelopeConfirm: false,
      errors: {
        hasErrors: false,
        errorsArray: [],
      },
      filesConfig: [
        {
          name: 'Конверт',
          types: ['application/pdf'],
          typesForChose: ['application/pdf'],
          id: null,
          fileType: 'KONVERT'
        },
      ]
    }
  },
  computed: {
    ...mapGetters('checkFilled', {
      organizationSendKonvert: 'organizationSendKonvert',
      organizationBlocked: 'organizationBlocked',
      getBlockInfoOrganization: 'getBlockInfoOrganization',
      currentStage: 'currentStage'
    }),
    ...mapGetters('keycloak', {getFakeUser: 'getFakeUser', userId: 'userId'}),
    blockBtn() {
      if (this.getAuthData?.realm_access?.roles?.includes('ADMIN_ROLE')) {
        return false
      } else if (this.currentStage === 5 || this.organizationSendKonvert) {
        return true
      } else {
        return false
      }
    },
    receiptDate() {
      if (this.getBlockInfoOrganization.konvertAcceptDate) {
        return moment(this.getBlockInfoOrganization.konvertAcceptDate).format('LLL')
      } else {
        return '';
      }
    },
    konvertAcceptStatus() {
      if (this.getBlockInfoOrganization.konvertAccept === true) {
        return 'accept'
      } else if (this.getBlockInfoOrganization.konvertAccept === false) {
        return 'reject'
      } else if (this.getBlockInfoOrganization.konvertAccept === null) {
        return 'in-process'
      } else {
        return ''
      }
    },
    
    konvertAcceptText() {
      if (this.getBlockInfoOrganization.konvertAccept === true) {
        return 'Конверт принят'
      } else if (this.getBlockInfoOrganization.konvertAccept === false) {
        return 'Конверт отклонен'
      } else {
        return 'Ожидайте приема конверта'
      }
    },
  },
  methods: {
    blockOrg() {
      this.loading = true;
      UserController.setBlockOrganization(!this.organizationBlocked, "ORG_BLOCK")
        .then((data) => {
          if (data.hasErrors) {
            this.errors.hasErrors = true
            this.errors.errorsArray = data.errors
          }
        })
        .finally(() => this.loading = false)
    },
    async blockKonvertOrg() {
      this.loadingKonvert = true;
      UserController.setBlockOrganization(true, "KONVERT_BLOCK").finally(() => this.loadingKonvert = false)
      this.envelopeConfirm = false
    },
    async getReport() {
      this.loadingFile = true;
      await this.downloadBlockPrint(this.userId)
      this.loadingFile = false;
    },
    
    // xxx(item) {
    //   console.log(item)
    //
    //   const indexes = [];
    //
    //   for (let index = 0; index < item.length; index++) {
    //     if (item[index] === '|') {
    //       indexes.push(index);
    //     }
    //   }
    //
    //   // console.log(indexes)
    //
    //   let x = '';
    //   let y = 0;
    //
    //   for (let a = 0; a < indexes.length; a++) {
    //     x = `${x} ` + `${item.slice(y, indexes[a])}\n` + `\n`
    //     y = indexes[a]
    //   }
    //
    //   console.log(x.replace('|', ''));
    //   return String (x.replace('|', ''))
    // }
  },
}
</script>

<style lang="sass">
.accept
  .application__status
    color: #155724 !important
    background: #d4edda !important
    border: 1px solid #c3e6cb !important


.reject
  .application__status
    color: #721c24 !important
    background: #f8d7da !important
    border: 1px solid #f5c6cb !important

.in-process
  .application__status
    color: #343434 !important
    background: #a8a8a8 !important
    border: 1px solid #343434 !important

.application-moderate
  text-align: center

.convert_span
  font-size: 12px
  font-weight: 400
</style>